import { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import LogoTiles from './LogoTiles';

const NAV_LINKS = [
  { label: 'Features',    href: '/#features'   },
  { label: 'How to Play', href: '/#how'         },
  { label: 'Daily',       href: '/#daily'       },
  { label: 'Themes',      href: '/#themes'      },
  { label: 'Support',     href: '/support', route: true },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  const closeMenu = useCallback(() => setOpen(false), []);
  const toggleMenu = useCallback(() => setOpen((v) => !v), []);

  useEffect(() => { setOpen(false); }, [pathname]);

  useEffect(() => {
    if (!open) return;

    const onKeyDown = (e) => {
      if (e.key === 'Escape') closeMenu();
    };

    document.addEventListener('keydown', onKeyDown);
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = '';
    };
  }, [open, closeMenu]);

  return (
    <>
      <nav className="navbar">
        <Link to="/" className="navbar-brand" onClick={closeMenu}>
          <img src="/assets/logo.png" alt="Lexira" className="navbar-logo-img" />
          <LogoTiles size="nav" />
        </Link>

        <ul className="navbar-links">
          {NAV_LINKS.map((l) => (
            <li key={l.label}>
              {l.route
                ? <Link to={l.href} className={`navbar-link ${pathname === l.href ? 'is-active' : ''}`}>{l.label}</Link>
                : <a href={l.href} className="navbar-link">{l.label}</a>
              }
            </li>
          ))}
        </ul>

        <div className="navbar-right">
          <a href="/#download" className="navbar-cta">Download Free</a>
          <button
            type="button"
            className={`navbar-burger ${open ? 'is-open' : ''}`}
            onClick={toggleMenu}
            aria-label={open ? 'Close menu' : 'Open menu'}
            aria-expanded={open}
            aria-controls="navbar-drawer"
          >
            <span /><span /><span />
          </button>
        </div>
      </nav>

      <button
        type="button"
        className={`navbar-backdrop ${open ? 'is-open' : ''}`}
        aria-label="Close menu"
        aria-hidden={!open}
        tabIndex={open ? 0 : -1}
        onClick={closeMenu}
      />

      <div
        id="navbar-drawer"
        className={`navbar-drawer ${open ? 'is-open' : ''}`}
        aria-hidden={!open}
      >
        <ul className="navbar-drawer-links">
          {NAV_LINKS.map((l) => (
            <li key={l.label}>
              {l.route
                ? <Link to={l.href} className="navbar-drawer-link" onClick={closeMenu}>{l.label}</Link>
                : <a href={l.href} className="navbar-drawer-link" onClick={closeMenu}>{l.label}</a>
              }
            </li>
          ))}
          <li>
            <a href="/#download" className="navbar-drawer-cta" onClick={closeMenu}>
              Download Free
            </a>
          </li>
        </ul>
      </div>
    </>
  );
}
